import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';

const MyButton = forwardRef(function MyIconButton(
  {
    children,
    onClick,
    tip,
    btnClassName,
    tipClassName,
    placement = 'top',
    arrow = true,
    disabled = false,
    size = 'small',
    ...iconButtonProps
  },
  ref
) {
  const button = (
    <IconButton
      ref={ref}
      onClick={onClick}
      className={btnClassName}
      disabled={disabled}
      size={size}
      {...iconButtonProps}
    >
      {children}
    </IconButton>
  );

  // Envolver siempre en <span> permite que el Tooltip funcione cuando disabled=true
  return (
    <Tooltip title={tip} className={tipClassName} placement={placement} arrow={arrow}>
      <span style={{ display: 'inline-flex' }}>{button}</span>
    </Tooltip>
  );
});

MyButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  tip: PropTypes.node,
  btnClassName: PropTypes.string,
  tipClassName: PropTypes.string,
  placement: PropTypes.oneOf([
    'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left',
    'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'
  ]),
  arrow: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default MyButton;